let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hshed")).then(() => parcelRequire('bPKZ5'));